import React from 'react';
import { injectIntl } from 'react-intl';

function ActivityElement({
  intl, titleTraductionId, headerContent, children,
}:any) {
  return (
    <div className="bodyCard flexRow spaceBetween">
      <div>
        <h3>{intl.formatMessage({ id: titleTraductionId })}</h3>
        {headerContent}
      </div>
      <div className="flexCol spaceBetween">
        {children}
      </div>
    </div>
  );
}
export default injectIntl(ActivityElement);
